import { Button, Tooltip } from "antd";
import { LeftCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { forwardRef, useEffect } from "react";
import i18next from "i18next";

import { views_state } from "../../../features/views/viewsSlice";

const ButtonPreView = forwardRef(({ view, setMapView, currentView, setCurrentView }, ref) => {

    const viewsState = useSelector(views_state);

    useEffect(() => {
        //console.log('view', view)
        //console.log('ref', ref.current)
        view.ui.add(ref.current, {position: 'bottom-right', index: 1})
    }, [])

    
    /**
     * Función que muestra la visualización en la vista previa a la actual cuando se clica en el botón de 'Zoom Anterior'
     */
    const onClick = () => {
        //setCurrentView(currentView-1)
        //console.log('current view', currentView)
        view.when(function () {
            if(viewsState.length > 1 && 0 < currentView) {
                //console.log('views', viewsState)
                let viewIndex = currentView -1
                let viewNow = viewsState[viewIndex]
                view.center = viewNow.center
                view.scale = viewNow.scale
                //console.log('pre center',view.center)
                //console.log('pre scale', view.scale)
                setMapView(view)
                setCurrentView(currentView-1)
            }
            console.log('currentView en pre', currentView)
            //setMapView(view)
        })
            .catch(function (err) {
                console.error("MapView rejected:", err);
            });
    }

    return (
        <>
            <div ref={ref}>
                <Tooltip title={i18next.t('common.tools.button_pre_view.name')} placement="bottomLeft">
                    <Button icon={<LeftCircleOutlined />} onClick={onClick}></Button>
                </Tooltip>
            </div>
        </>

    )
})

export default ButtonPreView;